module.exports = {
  login: {
    titles: '欢迎登录海店汇后台管理系统',
	titlesNew: '欢迎登录四维汇后台管理系统',
    zhang: '没有账号',
    registerNow: '立即注册',
    accountName: '账户名',
    passwordName: '密码',
    Chinese: '中文',
    English: '英文',
    account: '请输入账号',
    password: '请输入密码',
    confirmPas: '请输入确认密码',
    sign: '登录',
    register: '注册',
    forget: '忘记密码',
    code: '请输入验证码',
    emptyAcc: '账户名不能为空',
    emptyPass: '密码不能为空',
    emptyVer: '验证码不能为空',
    emptyMobile: '手机号不能为空',
    Suremobile: '请输入正确的手机号',
    Verification: '验证码',
    language: '请选择语言',
    phone: '手机号',
    Sms: '验证码',
    getCode: '获取验证码',
    next: '下一步',
    modify: '您正在修改',
    email: '请输入手机号',
    trueEmail: '请输入正确的手机号',
    EnterPas: '请输入6-20位数字和字母的组合',
    mailbox: '邮箱不能为空'
  },
  register: {
    titles: '欢迎注册海店汇后台管理系统',
	titlesNew: '欢迎注册四维汇后台管理系统',
    email: '邮箱不可修改，请谨慎填写',
    phone: '请输入联系人的手机号',
    agreementLft: '我已阅读并同意',
    agreementAnd: '及',
    agreementRight: '软件许可使用协议',
    agreementPrivate: '隐私保护政策',
    password: '请输入登录密码，长度6-20位，数字+字母',
    newpassword: '请再次输入密码',
    cancel: '取消',
    register: '确认注册',
    Email: '注册邮箱',
    PhoneNumber: '联系电话',
    Password: '登录密码',
    ConfirmPassword: '确认密码',
    Code: '验证码',
    emptynewpas: '确认密码不能为空',
    reTiao: '稍后会有客服联系您，即将跳到登录页面',
    success: '恭喜您注册成功！',
    Submit: '立即提交',
    equal: '两次密码不相等'
  }
  // luyou: [
  //   {
  //     name: "计划",
  //     icon: "icon-icondaxiaomobandefuben-04",
  //     children: [
  //       { path: "/jihua1", name: "计划管理1" },
  //     ]
  //   },
  //   {
  //     name: "其他",
  //     icon: "icon-icondaxiaomobandefuben-04",
  //     children: [
  //       { path: "/jihua2", name: "计划管理2" },
  //     ]
  //   },
  // ],
  // guan: {
  //   guan1: '管理1',
  //   guan2: '管理2'
  // },
  // login: {
  //   titles: '后台管理系统',
  //   rember: '记住我',
  //   sign: '登录',
  //   register: '注册',
  //   forget: '忘记密码',
  //   chinese: '中文',
  //   English: '英文'
  // },
  // con: {
  //   chang: '常规',
  //   geren: '个人'
  // },
  // left: {
  //   cai1: '菜单1',
  //   cai2: '菜单2'
  // },
  // title: {
  //   home: '首页',
  //   message: '信息',
  //   code: '技术评估'
  // }
}
